import { render, staticRenderFns } from "./WidgetServicios.vue?vue&type=template&id=624b103f&"
import script from "./WidgetServicios.vue?vue&type=script&lang=js&"
export * from "./WidgetServicios.vue?vue&type=script&lang=js&"
import style0 from "./WidgetServicios.vue?vue&type=style&index=0&id=624b103f&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports